var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_MessageType_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-message-type"),
      filterable: "",
    },
    on: {
      activated: _vm.activated,
      new: _vm.toNew,
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                totalCount: _vm.totalCount,
                "filter-page-data": _vm.filterPageData,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.code",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.message_type_code)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.message_type_name)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.type",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.message_type_label)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          viewBtn: _vm.hasBtn("view-admin-message-type"),
                          delBtn: _vm.hasBtn("delete-admin-message-type"),
                          editBtn: _vm.hasBtn("edit-admin-message-type"),
                          editText:
                            "label_essweb_list_components_tools_editBtnLabel",
                          title: _vm.$t("label_essweb_MessageType_list_title"),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toView,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newMessageType", {
              attrs: { show: _vm.showNewType },
              on: {
                close: function ($event) {
                  _vm.showNewType = false
                },
                new: _vm.onNew,
              },
            }),
            _c("editMessageType", {
              attrs: { show: _vm.showEditType, curUuid: _vm.curUuid },
              on: {
                close: function ($event) {
                  _vm.showEditType = false
                  _vm.curUuid = null
                },
                save: _vm.onSave,
              },
            }),
            _c("viewMessageType", {
              attrs: { show: _vm.showViewType, curUuid: _vm.curViewUuid },
              on: {
                close: function ($event) {
                  _vm.showViewType = false
                  _vm.curViewUuid = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }